import { DashboardConstants } from '../../actions/constant';

const {
  GET_DASHBOARD_SUPERVISOR_EDIT_REQUEST,
  GET_DASHBOARD_SUPERVISOR_EDIT_SUCCESS,
  GET_DASHBOARD_SUPERVISOR_EDIT_FAILURE,
  GET_DASHBOARD_SUPERVISOR_EDIT_RESET,
} = DashboardConstants;

const initialstate: object = {
  response: null,
  loading: false,
};

export const dashboardSupervisorEditReducer = (state = initialstate, action: any) => {
  switch (action.type) {
    case GET_DASHBOARD_SUPERVISOR_EDIT_SUCCESS: {
      return {
        ...state,
        response: action.payload?.data,
        loading: false,
      };
    }

    case GET_DASHBOARD_SUPERVISOR_EDIT_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
      };

    case GET_DASHBOARD_SUPERVISOR_EDIT_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case GET_DASHBOARD_SUPERVISOR_EDIT_RESET:
      return initialstate;

    default:
      return state;
  }
};
